import { Button } from "@alm/flow-ds/components";
import React from "react";
import { FormDataValue } from "lib/api/types";

interface Props {
	value: FormDataValue;
	label: string;
	elem?: string;
	link?: string;
	onValueClick?: (value: FormDataValue, index?: number) => void;
	onValueClickLabel?: string;
	index?: number;
}

// only work for lookup
function DisplayOnlyValue({
	value,
	label,
	elem,
	link,
	onValueClick,
	onValueClickLabel,
	index,
}: Props) {
	return (
		<div className="display-only-element">
			<div className="elem__label">{label}</div>
			{Array.isArray(value) ? (
				value.map((v, i) => {
					if (v === undefined) return null;
					return (
						<div
							key={`${v === null ? "no-val" : v.toString()}_${i}`}
							className="display-only-value">
							{elem === "reference" && link && onValueClick ? (
								<Button
									className="btn btn-link p-0 text-left"
									onClick={() => onValueClick(v, i)}
									aria-label={onValueClickLabel}>
									{v}
								</Button>
							) : (
								v
							)}
						</div>
					);
				})
			) : (
				<div className="display-only-value">
					{elem === "reference" && link && onValueClick ? (
						<Button
							className="btn btn-link p-0 text-left"
							onClick={() => onValueClick(value, index)}
							aria-label={onValueClickLabel}>
							{value}
						</Button>
					) : (
						value
					)}
				</div>
			)}
		</div>
	);
}

export default React.memo(DisplayOnlyValue);
